import { PaginatedAiAdminTrackingPayload } from 'app/modules/aiAdmin/requests';

const BASE = ['ai_admin'] as const;

export const AI_ADMIN_QUERY_KEYS = {
  getAiAdminTracking: (payload: PaginatedAiAdminTrackingPayload) =>
    [...BASE, 'tracking', payload] as const,
  getAiAgents: () => [...BASE, 'agents'] as const,
  getAiStats: () => [...BASE, 'stats'] as const,
};
